import { AnsweredQuestion } from '../useAppraisalFlow'
import useTranslation from 'next-translate/useTranslation'

export interface SummaryPanelProps {
  description: string
  answeredQuestions: AnsweredQuestion[]
  itemLabel: string
}

export default function SummaryPanel({
  description,
  answeredQuestions,
  itemLabel,
}: SummaryPanelProps) {
  const { t } = useTranslation('wertCheck')

  return (
    <aside className="bg-static-white rounded-xl shadow-[0_0_2rem_rgba(0,0,0,0.1)] p-4 flex flex-col gap-3 h-fit">
      <h2 className="text-heading-2xs text-primary uppercase tracking-wide">
        {t('summary_title')}
      </h2>

      <SummaryRow label={t('summary_description_label')} value={description} />

      {answeredQuestions.map((answer, index) => (
        <SummaryRow
          key={index}
          label={answer.questionTitle}
          value={answer.valueLabel}
        />
      ))}

      {itemLabel && (
        <SummaryRow label={t('summary_rated_as')} value={itemLabel} />
      )}
    </aside>
  )
}

function SummaryRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex flex-col border-t border-secondary pt-2">
      <span className="text-s text-secondary uppercase">{label}</span>
      <span className="text-m text-primary break-words">{value}</span>
    </div>
  )
}
